import React from 'react';

const Chart = () => {
  return (
    <div className="dark:text-white w-full px-4 sm:px-6 md:px-8 py-8 max-w-7xl mx-auto">
      <h2 className="font-vt323  text-[44px] sm:text-4xl md:text-[44px] text-center mb-6">
        chart
      </h2>

      <div className="relative w-full max-w-6xl mx-auto aspect-[4/5] sm:aspect-[16/9]">
      <iframe
        src="https://dexscreener.com/solana/4w2cysotX6czaUGmmWg13hDpY4QEMG2CzeKYEQyK9Ama?embed=1&loadChartSettings=0&trades=0&tabs=0&info=0&chartLeftToolbar=0&chartDefaultOnMobile=1&chartTheme=dark&theme=dark&chartStyle=0&chartType=usd&interval=15"
        className="absolute top-0 left-0 w-full h-full border-0 rounded-md"
        title="Dexscreener Chart"
        loading="lazy"
      />
      </div>
    </div>
  );
};

export default Chart;
